/** @format */

import React from 'react';
import AboutComp from '../../components/about';

export default function FaqPg(props) {
  return <AboutComp {...props}/>;
}
